const STORAGE_KEY = 'dh-theme';

export function initTopbar() {
  const html = document.documentElement;
  const toggle = document.querySelector('.topbar__theme');

  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored === 'dark' || stored === 'light') {
    setTheme(stored);
  }

  toggle?.addEventListener('click', () => {
    const next = html.getAttribute('data-theme') === 'dark' ? 'light' : 'dark';
    setTheme(next);
    localStorage.setItem(STORAGE_KEY, next);
  });

  function setTheme(theme) {
    html.setAttribute('data-theme', theme);
    toggle?.setAttribute('aria-pressed', String(theme === 'dark'));
    document.querySelector('meta[name="theme-color"]')?.setAttribute(
      'content',
      theme === 'dark' ? '#0a0a0a' : '#e9e6e1'
    );
  }
}
